import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwo = {
  content?: string;
  type?: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfoAllOfTwoType;
};
